import { svgToDataURL } from "common/utils";
import {
  TOLL_MARKER_HEIGHT,
  TOLL_MARKER_WIDTH,
} from "components/Map/constants/icons";

const svIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<g clip-path="url(#clip0_3047_45834)">
<g filter="url(#filter0_ddd_3047_45834)">
<rect x="1.66602" y="1.66699" width="16.6667" height="16.6667" rx="4" fill="#3B82F6"/>
<rect x="2.06602" y="2.06699" width="15.8667" height="15.8667" rx="3.6" stroke="#2164CF" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.0271 12.0701C12.4999 12.5935 11.7738 12.9169 10.9722 12.9169C9.89264 12.9169 8.95006 12.3303 8.44575 11.4586H10V10.4863H8.09588C8.06936 10.3282 8.05556 10.1658 8.05556 10.0002C8.05556 9.83459 8.06936 9.67219 8.09588 9.51411H10V8.54188H8.44575C8.95006 7.67009 9.89264 7.08355 10.9722 7.08355C11.7814 7.08355 12.5137 7.4131 13.0421 7.94532L13.7296 7.25785C13.0252 6.5497 12.0499 6.11133 10.9722 6.11133C9.34016 6.11133 7.94292 7.11669 7.36602 8.54188H5.625V9.51411H7.11342C7.09356 9.67335 7.08333 9.83559 7.08333 10.0002C7.08333 10.1648 7.09356 10.3271 7.11342 10.4863H5.625V11.4586H7.36602C7.94292 12.8837 9.34016 13.8891 10.9722 13.8891C12.0423 13.8891 13.0114 13.4569 13.7146 12.7575L13.0271 12.0701Z" fill="white"/>
</g>
<defs>
<filter id="filter0_ddd_3047_45834" x="0.666016" y="0.666992" width="18.666" height="19.667" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.16 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3047_45834"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_3047_45834" result="effect2_dropShadow_3047_45834"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.12 0"/>
<feBlend mode="normal" in2="effect2_dropShadow_3047_45834" result="effect3_dropShadow_3047_45834"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_3047_45834" result="shape"/>
</filter>
<clipPath id="clip0_3047_45834">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>`;

export const getTollIcon = () => {
  return {
    url: svgToDataURL(svIcon),
    width: TOLL_MARKER_WIDTH,
    height: TOLL_MARKER_HEIGHT,
    anchorY: TOLL_MARKER_HEIGHT / 2,
  };
};
